export const TASK_INFO = ['TRANSFER_OUTBOUND_TASK_INFO'];
